function EEFormatToJSDate(timestamp, ee_format){

    /*
        https://docs.expressionengine.com/latest/templates/date-variable-formatting.html

        %F	month, textual, long	“January”
        %j	day of the month without leading zeros	“1” to “31”
        %g	hour, 12-hour format without leading zeros	“1” to “12”
        %i	minutes	“00” - “59”
        %a		“am” / “pm”
        %l	(lowercase ‘L’) - day of the week, textual, long	“Friday”
        %n	month without leading zeros	“1” to “12”
        %Y	year, 4 digits	“1999”
        %d	day of the month, 2 digits with leading zeros	“01” to “31”
        %D	day of the week, textual, 3 letters	“Fri”
        %e	Timezone identifier	UTC, GMT, Atlantic/Azores

     */

    var moment_format = ee_format.replace("%F","MMMM");
    moment_format = moment_format.replace("%j","D");
    moment_format = moment_format.replace("%g","h");
    moment_format = moment_format.replace("%i","mm");
    moment_format = moment_format.replace("%a","a");
    moment_format = moment_format.replace("%A","A");
    moment_format = moment_format.replace("%l","dddd");
    moment_format = moment_format.replace("%n","M");
    moment_format = moment_format.replace("%Y","YYYY");
    moment_format = moment_format.replace("%D","ddd");
    moment_format = moment_format.replace("%d","DD");

    moment_format = moment_format.replace("%e","zz");
    return moment(timestamp * 1000).tz(moment.tz.guess()).format(moment_format);

}

function updateDates($section = ""){
    let $selector = $section.length ? $section : $(document);
    $selector.find('.date-time-container').each(function () {
        let timestamp = $(this).data('timestamp');
        let children_items = $(this).find('.date-time-item');

        if(children_items.length>0){
            children_items.each(function () {
                $(this).text(EEFormatToJSDate(timestamp, $(this).data('format')));
            });
        }else{
            $(this).text(EEFormatToJSDate(timestamp, $(this).data('format')));
        }
    });
}

$(document).ready(function() {
    updateDates();
    $(document).on("timezoneUpdate",function (event) {
        updateDates($(event.target));
    });
});